import * as React from 'react';
function SvgCustomCashPaymentCoinJpy(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentcolor"
      className="custom-cash-payment-coin-jpy_svg__fil-icon"
      {...props}
    >
      <path d="M7.457 9.228l2.872-2.713c.322-.215.7-.33 1.087-.33H15.1c.685 0 1.32.358 1.674.945l.35.578c.35.576.378 1.29.076 1.892l-.317.634a1.955 1.955 0 01-2.133 1.043l-3.162-.632a.647.647 0 00-.488.1 1.937 1.937 0 00-.859 1.811.754.754 0 00.478.629l5.349 2.057c.412.158.865.173 1.286.041l5.709-1.783m-.001-7.729L18.7 3.084a1.965 1.965 0 00-1.145-.284l-7.022.413a1.957 1.957 0 00-1.185.487l-3.5 3.115a1.948 1.948 0 00-.556.843l-.675 2.013m3.607-.327a5.992 5.992 0 104.588 4.636M5.25 12.5v.75a1.5 1.5 0 003 0v-.75m-1.5 2.25v3.75M5.25 17h3" />
    </svg>
  );
}
export default SvgCustomCashPaymentCoinJpy;
